module.exports = __webpack_public_path__ + "img/hcml_gallery1.6e0657f3.jpg";